{
	"backToStartPage": "Zpět na úvodní stránku",
	"transactionDetailsTitle": "Podrobnosti transakce",
	"btnVerifyTransactions": "Ověřte transakce",
	"kpi": {
		"date": "Datum",
		"quantity": "Množství",
		"carbonReductions": "Redukce uhlíku"
	},
	"verifyTransactionModal": {
		"title": "Ověřte transakci",
		"description": "Zadejte ID záznamu pro tuto transakci. Informace najdete v prohlášení.",
		"recordIdLabel": "ID záznamu",
		"cancelTitle": "Zrušit",
		"verifyTitle": "Ověřte",
		"errors": {
			"recordIdRequired": "Je vyžadováno ID záznamu",
			"recordIdInvalid": "ID záznamu musí mít 16 znaků (písmen nebo číslic), formátováno jako ABCD 1234 EFGH 5678",
			"verificationFailed": "Transakci se nepodařilo ověřit. Zkontrolujte ID záznamu"
		}
	},
	"errors": {
		"notFound": "Transakce nenalezena"
	}
}
